export default {
  header: 'Bewertungstest hinzufügen',
  description: 'Wählen Sie die Art der Bewertung, die Sie hinzufügen möchten, indem Sie auf eine der Schaltflächen klicken.',
  createTable: 'Tabelle',
  createChart: 'Grafik',
  createImage: 'Bild',
  createFile: 'Datei',
};
